import printMonthHeaderUrl from './printMonthHeader.html';
export default {
  templateUrl: printMonthHeaderUrl,
  controllerAs: 'ctrl',
  bindings: {
    date: '<',
    currentDays: '<',
  },
};
